"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    partitionBreadcrumbItems: function() {
        return _partitionBreadcrumbItems.partitionBreadcrumbItems;
    },
    truncateBreadcrumbLongName: function() {
        return _truncateBreadcrumb.truncateBreadcrumbLongName;
    },
    truncateBreadcrumLongTooltip: function() {
        return _truncateBreadcrumb.truncateBreadcrumLongTooltip;
    },
    isTruncatableBreadcrumbContent: function() {
        return _truncateBreadcrumb.isTruncatableBreadcrumbContent;
    }
});
const _partitionBreadcrumbItems = require("./partitionBreadcrumbItems");
const _truncateBreadcrumb = require("./truncateBreadcrumb");
